import React from "react"
import { formatMoney, formatDateTime, formatDiscount } from "../transactions/format"

// Subscriptions on record for the merchant (doc 06 detail). Empty-safe.
export function SubscriptionPanel({ subscriptions, copy }) {
  const c = copy.subscriptions
  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-6">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{c.heading}</h2>
      {subscriptions.length === 0 ? (
        <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">{c.empty}</p>
      ) : (
        <ul className="mt-4 divide-y divide-gray-100 dark:divide-gray-800">
          {subscriptions.map((s) => (
            <li key={s.id} className="flex items-start justify-between py-3">
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-medium text-gray-900 dark:text-gray-100">{s.plan_name || copy.none}</span>
                  {s.test_charge && (
                    <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-500 dark:bg-gray-800 dark:text-gray-400">
                      {c.testChargeBadge}
                    </span>
                  )}
                  {formatDiscount(s) && (
                    <span className="rounded-full bg-indigo-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-indigo-700 dark:bg-indigo-950/40 dark:text-indigo-300">
                      {c.discountBadge}: {formatDiscount(s)}
                    </span>
                  )}
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  {c.statuses[s.status] || s.status} · {formatDateTime(s.activated_at)}
                  {s.cancelled_at ? ` → ${formatDateTime(s.cancelled_at)}` : ""}
                </div>
              </div>
              <div className="text-right tabular-nums font-semibold text-gray-900 dark:text-gray-100">
                {formatMoney(s.price_cents, s.currency)}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
